export enum BookTypeEnum {
  Novel = 0,
  Comic = 100,
  Publish = 200,
}

export enum BookStatusEnum {
  All = -1,
  Ongoing = 30,
  Completed = 50,
}
export enum CategoryTypeEnum {
  novel = 1,
  fanfic = 4,
  comic = 2,
  publishBook = 3,
}

interface ITagInfo {
  tagName: any;
  id?: number;
  name?: string;
}

export interface IBook {
  bookId: string;
  name: string;
  bookName?: string;
  description?: string;
  authorName?: string;
  chapterCnt?: number;
  coverId?: number;
  isInBookshelf?: boolean;
  itemType?: BookTypeEnum;
  lastChapterTime?: number | string;
  recommendMsg?: string;
  status?: BookStatusEnum;
  statusDesc?: string;
  updateTime?: number;
  categoryName?: string;
  categoryType?: CategoryTypeEnum;
  tagInfo?: ITagInfo[];
  tagInfos?: ITagInfo[];
  discount?: string | number;
  price?: string | number;
  originalPrice?: string | number;
  languageCode?: number;
  newChapterName?: string;
  pvNum?: string | number;
  flag?: {
    code?: string;
    emoji?: string;
    name?: string;
    unicode?: string;
  };
}
